/**
 * The public projection of a storefront template.
 *
 * Kept in its own leaf file, not on the service, because `StoreConfigService`
 * (tenancy) needs it while `StorefrontTemplatesService` needs `StoreConfigService`
 * for cache invalidation. Importing it from the service instead creates a
 * module cycle, and under `emitDecoratorMetadata` that cycle silently degrades
 * an injected constructor parameter's type to `Object` — Nest then fails to
 * resolve the provider at runtime rather than at compile time.
 *
 * `isActive` / `deletedAt` are deliberately absent: they are filter criteria,
 * not payload. `/store/config` selects them on top of this because deciding
 * whether an applied template is still usable is exactly what they are for.
 */
export const STOREFRONT_TEMPLATE_SELECT = {
  id: true,
  name: true,
  slug: true,
  description: true,
  previewImageUrl: true,
  tier: true,
  metadata: true,
  isPublished: true,
  sortOrder: true,
  createdAt: true,
  updatedAt: true,
};
